class Controller {
  constructor(Events, $mdDialog) {
    "ngInject";

    this.Events = Events;
    this.$mdDialog = $mdDialog;
  }
  $onInit() {
    const confirm = this.$mdDialog
      .confirm()
      .title(`Are you sure you want to remove "${this.name}"?`)
      .textContent("If you chose to remove it you can add it again.")
      .ok("Remove")
      .cancel("Cancel");

    this.enableField = () => {
      this.selected.isDisabled = false;
    };

    this.onClear = () => {
      this.$mdDialog.show(confirm).then(
        () => {
          this.selected.name = null;
          const methodName = this.resourceMethodName;
          const options = {
            key: this.name,
            name: null,
            methodName,
          };

          this.Events.emit(this.eventName, options);
        },
        () => {}
      );
    };

    this.submitField = () => {
      this.selected.key = this.selected.key ? this.selected.key : this.name;
      this.selected.methodName = this.resourceMethodName;
      this.Events.emit(this.eventName, this.selected);
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/editableTextarea/editableTextarea.controller.js